import React from "react";
import PropTypes from "prop-types";
import firebase from "firebase";
import AddPostForm from "./AddPostForm";
import EditPostForm from "./EditPostForm";
import base, { firebaseApp } from "../base";
import Login from "./Login";


class ContentManagement extends React.Component {
  static propTypes = {
    posts: PropTypes.object.isRequired,
    updatePost: PropTypes.func.isRequired,
    deletePost: PropTypes.func.isRequired,
    loadSamplePosts: PropTypes.func.isRequired
  };

  state = {
    uid: null,
    owner: null
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        this.authHandler({ user });
      }
    })
  };

  authHandler = async (authData) => {
    // 1. Look up the current path in the firebase database
    const path = await base.fetch(this.props.path, { context: this });
    // 2. Claim it if there is no owner
    if (!path.owner) {
      // save it as our own
      await base.post(`${this.props.path}/owner`, {
        data: authData.user.uid
      });
    }
    // 3. Set the state of the Content Management component to reflect the current user
    this.setState({
      uid: authData.user.uid,
      owner: path.owner || authData.user.uid
    })
  };

  authenticate = provider => {
    const authProvider = new firebase.auth[`${provider}AuthProvider`]();
    firebaseApp.auth().signInWithPopup(authProvider).then(this.authHandler);
  };

  logout = async () => {
    await firebase.auth().signOut();
    this.setState({ uid: null });
  };
  
  render () {
    const logout = <button onClick={this.logout}>Log Out!</button>;

    // 1. Check if they are logged in
    if (!this.state.uid) {
      return <Login authenticate={this.authenticate} />;
    }
    // 2. Check if they are not the owner of the posts
    if (this.state.uid !== this.state.owner) {
      return (
        <div>
          <p>Sorry you are not the owner!</p>
          {logout}
        </div>
      )
    }
    // 3. They must be the owner, just render the inventory
    return (
      <div className="wrapper">
        <h2>Add New Posts or edit Old Ones</h2>

        {Object.keys(this.props.posts).map(key => (
          <EditPostForm 
            key={key}
            index={key}
            post={this.props.posts[key]}
            updatePost={this.props.updatePost}
            deletePost={this.props.deletePost}
          />
        ))}

        <AddPostForm addPost={this.props.addPost} />
        {logout}
        <button onClick={this.props.loadSamplePosts}>Load Sample Posts</button>
      </div>
    );
  }
}

export default ContentManagement;